import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { getIsWatchingProfileOwner } from '../../../../selectors/users';

export default connect((state: AppState) => ({
  isProfileOwnerWatchingCurrentUser: getIsWatchingProfileOwner(state),
}));
